import React, { useState } from 'react';
import { Building2, Zap, Shield, Users } from 'lucide-react';
import { FacilityCard } from '../components/FacilityCard';
import { facilities } from '../data/facilities';

export function Facilities() {
  const [isLoading] = useState(false);

  const totalCapacity = facilities.reduce((sum, f) => sum + parseInt(f.capacity), 0);
  const averageUptime = facilities.reduce((sum, f) => sum + f.uptime, 0) / facilities.length;
  const uniqueCountries = new Set(facilities.map(f => f.country)).size;

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Global Mining Facilities
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Secure, efficient, and sustainable mining facilities across the globe. 
            Choose from our network of premium locations for your mining operations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-blue-50 rounded-lg">
                <Building2 className="w-5 h-5 text-blue-500" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">{facilities.length} Facilities</h3>
            </div>
            <p className="text-gray-600">Across {uniqueCountries} Countries</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-green-50 rounded-lg">
                <Zap className="w-5 h-5 text-green-500" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">
                {totalCapacity} MW
              </h3>
            </div>
            <p className="text-gray-600">Total Capacity</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-purple-50 rounded-lg">
                <Shield className="w-5 h-5 text-purple-500" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">
                {averageUptime.toFixed(2)}%
              </h3>
            </div>
            <p className="text-gray-600">Average Uptime</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-orange-50 rounded-lg">
                <Users className="w-5 h-5 text-orange-500" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">1000+</h3>
            </div>
            <p className="text-gray-600">Active Clients</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {facilities.map((facility) => (
            <FacilityCard key={facility.id} facility={facility} />
          ))}
        </div>
      </div>
    </div>
  );
}